// extracted by mini-css-extract-plugin
export default {"container":"zq-z","heading":"Aq-z","text":"Bq-z","info":"Cq-z","link":"Dq-z","fullMaxWidth":"Eq-z"};